/**
 * KLUB-245 — integer version of the mobile app's JS code.
 *
 * This is NOT the store version (`Constants.expoConfig.version`): that string
 * is the EAS runtime (`runtimeVersion: { policy: "appVersion" }`) and diverges
 * between `main` (1.0.0) and the installed binaries (1.0.1), so it cannot be
 * compared. `CODE_VERSION` is bumped by hand on every OTA publication and is
 * compared against `tenants.min_app_code_version` (the club's minimum version).
 *
 * `apps/mobile/app.config.ts` declares the same number as a literal in
 * `extra.codeVersion` because Expo's config evaluator does not transpile local
 * TS imports. `tests/shared/code-version-mirror.test.ts` keeps both in lockstep.
 *
 * Publication steps: docs/runbooks/2026-10-15-publicar-ota.md.
 */
export const CODE_VERSION: number = 26;

/**
 * Range of the Postgres `integer` column `tenants.min_app_code_version` — not
 * a policy ceiling (there is none). Above it Postgres would answer a raw 500.
 */
export const PG_INT_MAX = 2147483647;

/** pt-BR text for a minimum that is not an integer >= 1 (platform UI and edge function). */
export const INVALID_MIN_VERSION_TEXT =
  "A atualização mínima precisa ser um número inteiro a partir de 1, ou vazio.";

/**
 * A storable minimum: an integer from 1 to `PG_INT_MAX`. `null` (no minimum)
 * is handled by each caller before this check. No imports, so the edge
 * function loads this file by relative path.
 */
export function isValidMinAppCodeVersion(n: unknown): n is number {
  return typeof n === "number" && Number.isInteger(n) && n >= 1 && n <= PG_INT_MAX;
}
